module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/image-placeholder-42884cd7086cc6b152d287755e62d40e.svg";